import {TravelTimeTransport} from "../types/TravelTimeTransport";
import {TravelTimeValues} from "../types/TravelTimeValues";

export const getTravelTimeDistance = (transport: TravelTimeTransport, time: TravelTimeValues) => {
    const calculateDistance = Math.ceil((30 * time) / 60);
    switch (transport) {
        case TravelTimeTransport.PUBLIC_TRANSPORT:
            return Math.ceil(calculateDistance / 2);
        case TravelTimeTransport.CAR:
        default:
            return calculateDistance;
    }
};
import {TravelTimeTransport} from "../types/TravelTimeTransport";
import {TravelTimeValues} from "../types/TravelTimeValues";

export const getTravelTimeDistance = (transport: TravelTimeTransport, time: TravelTimeValues) => {
    const calculateDistance = Math.ceil((30 * time) / 60);
    switch (transport) {
        case TravelTimeTransport.PUBLIC_TRANSPORT:
            return Math.ceil(calculateDistance / 2);
        case TravelTimeTransport.CAR:
        default:
            return calculateDistance;
    }
};
